// Client helpers to call server-side admin reservation functions (callables)
// Exposes functions that follow the project's dynamic-import pattern for Firebase Functions.

import { createManualReservation} from './defaultsService.js';

/**
 * Create multiple reservations in parallel. Returns Promise.allSettled results.
 * @param {Array} booths - array of booth objects { id, price, boothNumber, level, corner }
 * @param {Object} opts - { createdByProfileId, eventId, layoutId, vendorId, metadata }
 */
export const createManualReservationsBulk = async (booths = [], opts = {}) => {

  if (!Array.isArray(booths) || booths.length === 0) throw new Error('No booths provided');
  const { createdByProfileId, eventId, layoutId, vendorId, metadata } = opts || {};
  if (!eventId || !layoutId || !vendorId) throw new Error('Missing event/layout/vendor for bulk reservation');

  const promises = booths.map(b => {
    const payload = {
      action: "reserve",
      createdByProfileId: createdByProfileId || null,
      eventId,
      layoutId,
      boothId: b.id,
      vendorId,
      price: b.price ?? null,
      boothNumber: (b.number ?? b.boothNumber ?? b.id) ?? null,
      row: (b.row ?? null),
      col: (b.col ?? null),
      level: b.level ?? null,
      corner: (b.corner === 'Y' || b.corner === 'y' || b.corner === true) ? 'Y' : 'N',
      metadata: metadata || {},
    };
    return createManualReservation(payload);
  });

  return Promise.allSettled(promises);
};

/**
 * Create multiple reservations in parallel. Returns Promise.allSettled results.
 * @param {Array} booths - array of booth objects { id, price, boothNumber, level, corner }
 * @param {Object} opts - { createdByProfileId, eventId, layoutId, vendorId, metadata }
 */
export const releaseBoothsBulk = async (booths = [], opts = {}) => {

  if (!Array.isArray(booths) || booths.length === 0) throw new Error('No booths provided');
  const { createdByProfileId, eventId, layoutId, vendorId, metadata } = opts || {};
  if (!eventId || !layoutId || !vendorId) throw new Error('Missing event/layout/vendor for bulk reservation');

  const promises = booths.map(b => {
    const payload = {
      action: "release",
      createdByProfileId: createdByProfileId || null,
      eventId,
      layoutId,
      boothId: b.id,
      vendorId,
      boothNumber: (b.number ?? b.boothNumber ?? b.id) ?? null,
      row: (b.row ?? null),
      col: (b.col ?? null),
      level: b.level ?? null,
      corner: (b.corner === 'Y' || b.corner === 'y' || b.corner === true) ? 'Y' : 'N',
      price: b.price ?? null,
      metadata: metadata || {},
    };

    return createManualReservation(payload);

  });

  return Promise.allSettled(promises);
};
